export default __webpack_public_path__ + "static/media/music_player.b6851f3b.png";